import React, { useContext, useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import * as actionType from "../context/actions";
import DeleteInvoiceView from "./DeleteInvoiceView";
import PaginationView from "./PaginationView";
import { FilterdData } from "../helper/FilterdData";
import DataNotFoundView from "./DataNotFoundView";
import { useNavigate } from "react-router-dom";
import { Languages } from "../Utils/Languages";
import { PremiumFeatureOnlyModal } from "./PremiumFeatureOnlyModal";
import DeleteProformaInvoiceView from "./DeleteProformaInvoiceView";
import AddInvoiceDataInFirebase from "../data/Firebase/Invoice/AddInvoiceDataInFirebase";
import { AddInvoice, AddProformaInvoice, EditProformaInvoice, EditQuotation } from "../data";
import { toast } from "react-toastify";
import GetProformaInvoiceDataFirebase from "../data/Firebase/ProformaInvoice/GetProformaInvoiceDataFirebase";
import GetProformaInvoiceDataLocal from "../data/LocalStorage/ProformaInvoice/GetProformaInvoiceDataLocal";
import GetQuotationDataFirebase from "../data/Firebase/Quotation/GetQuotationDataFirebase";
import GetQuotationDataLocal from "../data/LocalStorage/Quotation/GetQuotationDataLocal";
import { Button, Modal } from "react-bootstrap";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { resolveAuditName } from "../Utils/audit_helper";
import Currancy from "../Utils/currency.json";


const ProformaTableDataLayer = ({ InvoicesData, selectedBusiness }) => {

    const navigate = useNavigate();


    const { state, dispatch } = useContext(ConfigContext);


    const [filterdInvoiceData, setFilterdInvoiceData] = useState(InvoicesData);
    const [enrichedInvoices, setEnrichedInvoices] = useState([]);
    const [isDisplayPrimiumFeatureModel, setIsDisplayPrimiumFeatureModel] = useState(false)
    const [showAlreadyInvoiceModal, setShowAlreadyInvoiceModal] = useState(false);


    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    useEffect(() => {
        setFilterdInvoiceData(FilterdData(state, InvoicesData, "creationDate"));
    }, [state])

    useEffect(() => {
        if (state?.USERID !== null) {
            GetProformaInvoiceDataFirebase(state, dispatch)
        }
        else {
            GetProformaInvoiceDataLocal(state, dispatch)
        }
    }, []);
    useEffect(() => {
        // Select all elements with data-bs-toggle="DefaultTooltipThree"
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="DefaultTooltipThree"]');
        // Initialize tooltips
        const tooltipList = Array.from(tooltipTriggerList).map(
            (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
        );
        // Cleanup on unmount
        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, []);



    const enrichInvoiceData = (invoices) => {
        return invoices.map((invoice, index) => {
            const matchedCustomer = state?.CUSTOMERS?.find(
                (cust) => cust.customerId?.toString() === invoice.customerId?.toString()
            );

            // Calculate due status
            let dueStatus = "No Due Date";
            if (invoice.dueDate) {
                let dueDateNum = parseInt(invoice.dueDate);
                if (dueDateNum.toString().length === 10) {
                    dueDateNum = dueDateNum * 1000;
                }
                const dueDate = new Date(dueDateNum);
                const today = new Date();
                dueDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const diffTime = dueDate.getTime() - today.getTime();
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays === 0) {
                    dueStatus = "Due Today";
                } else if (diffDays < 0) {
                    dueStatus = `${Math.abs(diffDays)} ${Math.abs(diffDays) === 1 ? "day" : "days"} overdue`;
                } else {
                    dueStatus = `${diffDays} ${diffDays === 1 ? "day" : "days"} remaining`;
                }
            }

            // Format issued date safely
            let issuedDateFormatted = "";
            try {
                const rawDate = invoice.date;
                if (rawDate) {
                    let ts = parseInt(rawDate);
                    if (!isNaN(ts)) {
                        if (ts.toString().length <= 10) ts *= 1000;
                        const d = new Date(ts);
                        if (!isNaN(d.getTime())) {
                            issuedDateFormatted = d.toDateString();
                        }
                    }
                }
            } catch (e) {
                issuedDateFormatted = "";
            }

            return {
                ...invoice,
                srNo: index + 1,
                customerName: matchedCustomer?.customer || "Unknown",
                issuedDateFormatted,
                paidStatusText: (invoice.paidFlagKey === "true" || invoice.paidFlagKey === true) ? "Paid" : "Unpaid",
                dueStatusText: dueStatus,
                converted: String(invoice?.converted) === "true" ? "true" : "false",
                convertedText: invoice?.converted === "true" ? "Converted" : "Pending"
            };
        });
    };

    const matchedInvoices = useMemo(() => {
        const filteredData = (selectedBusiness === null || selectedBusiness === "null")
            ? filterdInvoiceData
            : filterdInvoiceData.filter(invoice => invoice?.companyId == selectedBusiness);

        return enrichInvoiceData(filteredData); // use the same enrichment
    }, [filterdInvoiceData, selectedBusiness, state?.CUSTOMERS, state?.LANGUAGE]);



    const handleDropdownClick = (e, row) => {
        e.preventDefault();

        if (String(row?.converted).toLowerCase() === "true") {
            setShowAlreadyInvoiceModal(true);
            return;
        }
        else {
            const dropdown = e.currentTarget.nextElementSibling;
            if (dropdown) dropdown.classList.toggle("show");
        }
    };

    useEffect(() => {
        if (InvoicesData && Array.isArray(InvoicesData) && state?.CUSTOMERS) {
            const enriched = InvoicesData.map((invoice) => {
                const matchedCustomer = state.CUSTOMERS.find(
                    (cust) => cust.customerId?.toString() === invoice.customerId?.toString()
                );

                return {
                    ...invoice,
                    customerName: matchedCustomer?.customer || "Unknown",
                    converted: String(invoice?.converted) === "true" ? "true" : "false", // ensure consistency
                };
            });

            setEnrichedInvoices(enriched);
        }
    }, [InvoicesData, state?.CUSTOMERS]);



    // Pagination logic
    const totalPages = Math.ceil(matchedInvoices?.length / itemsPerPage);
    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return matchedInvoices.slice(start, start + itemsPerPage);
    }, [matchedInvoices, currentPage, itemsPerPage]);

    const sortCaret = (order, column) => {
        return (
            <span className="d-inline-flex align-items-center ms-2" >
                {!order ? (
                    <Icon icon="mdi:swap-vertical" className="text-muted" /> // Two arrows pointing up & down
                ) : order === "asc" ? (
                    <Icon icon="mdi:arrow-up-thick" className="text-muted" />
                ) : (
                    <Icon icon="mdi:arrow-down-thick" className="text-muted" />
                )}
            </span>
        );
    };
    function incrementLastPart(str) {

        const match = str?.match(/^(.*?)(\d+|[a-zA-Z])$/);

        if (!match) return str + "1"; // fallback

        const prefix = match[1];
        const lastPart = match[2];

        // If numeric
        if (!isNaN(lastPart)) {
            const incremented = (parseInt(lastPart) + 1)?.toString();
            return prefix + incremented;
        }

        // If single character (letter)
        const charCode = lastPart?.charCodeAt(0);
        let nextChar;

        if (lastPart >= 'a' && lastPart <= 'z') {
            nextChar = String.fromCharCode(charCode === 122 ? 97 : charCode + 1); // wrap 'z' → 'a'
        } else if (lastPart >= 'A' && lastPart <= 'Z') {
            nextChar = String.fromCharCode(charCode === 90 ? 65 : charCode + 1); // wrap 'Z' → 'A'
        } else {
            nextChar = lastPart;
        }

        return prefix + nextChar;
    }
    const ConvertToInvoice = (row) => {
        try {
            const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
            const isSharedRow = business?.isShared === true;
            const targetUid = isSharedRow ? business?.ownerUid : null;

            const doesExist = state?.INVOICES?.some(inv => inv.id === row?.id);

            let newInvoiceId;

            if (doesExist) {
                // Get latest invoice by creation date (safer than Number(id))
                const lastInvoiceId =
                    [...(state?.INVOICES || [])]
                        .sort((a, b) => Number(b.creationDate) - Number(a.creationDate))[0]?.id || "";

                // ⭐ USE YOUR increment function
                newInvoiceId = incrementLastPart(lastInvoiceId);
            } else {
                newInvoiceId = row?.id;
            }


            // Clone and update the row data
            const updatedInvoice = {
                ...row,
                converted: true,
            };
            const invoiceDataForFirebase = {
                ...row,
                customInvoiceId: row?.customInvoiceId
                    ? `PR-${row.customInvoiceId}`
                    : `PR-${row?.id}`,
                id: newInvoiceId,
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            };
            // ✅ use updatedInvoice here
            AddInvoice(state, dispatch, invoiceDataForFirebase, targetUid);

            // update proforma invoice
            EditProformaInvoice(state, dispatch, row?.uniqueID, updatedInvoice, targetUid);

            // update matching quotation if exists
            const matchedQuotation = state?.QUOTATION?.find(q => String(q.invoiceId) === String(row.invoiceId));
            if (matchedQuotation) {
                const updatedQuotation = {
                    ...matchedQuotation,
                    status: "Invoice"
                };
                console.log("updatedQuotation", updatedQuotation);
                EditQuotation(state, dispatch, matchedQuotation.uniqueID, updatedQuotation, targetUid);
            }

            if (state?.USERID !== null) {
                GetProformaInvoiceDataFirebase(state, dispatch);
                if (matchedQuotation) {
                    GetQuotationDataFirebase(state, dispatch);
                }
            } else {
                GetProformaInvoiceDataLocal(state, dispatch);
                if (matchedQuotation) {
                    GetQuotationDataLocal(state, dispatch);
                }
            }

            toast.success("Converted to invoice Successfully");
        } catch (error) {
            console.error("Conversion error:", error);
            toast.error("Failed to convert invoice. Please try again.");
        }
    };

    useEffect(() => {
        if (currentPage > totalPages && totalPages > 0) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage]);
    const { SearchBar } = Search;

    const isPremium = state?.PREMIUM?.length > 0;

    const handleDuplicate = (row) => {
        try {
            const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
            const isSharedRow = business?.isShared === true;
            const targetUid = isSharedRow ? business?.ownerUid : null;

            // Generate unique internal ID
            const newInvoiceUid = Date.now().toString() + Math.floor(Math.random() * 1000);

            // Generate unique ID (Serial Number) - Case Insensitive Check
            let newId = incrementLastPart(String(row.id));
            const allExistingIds = [
                ...(state?.INVOICES || []).map(inv => String(inv.id).toLowerCase()),
                ...(state?.PROFORMAINVOICES || []).map(inv => String(inv.id).toLowerCase()),
                ...(state?.QUOTATION || []).map(inv => String(inv.id).toLowerCase())
            ];

            while (allExistingIds.includes(newId.toLowerCase())) {
                newId = incrementLastPart(newId);
            }

            // Generate unique customInvoiceId if it exists - Case Insensitive Check
            let newCustomInvoiceId = row.customInvoiceId ? incrementLastPart(String(row.customInvoiceId)) : newId;
            const allExistingCustomIds = [
                ...((state?.INVOICES || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase())),
                ...((state?.PROFORMAINVOICES || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase())),
                ...((state?.QUOTATION || []).map(inv => String(inv.customInvoiceId || inv.id).toLowerCase()))
            ];

            if (row.customInvoiceId) {
                while (allExistingCustomIds.includes(newCustomInvoiceId.toLowerCase())) {
                    newCustomInvoiceId = incrementLastPart(newCustomInvoiceId);
                }
            }

            const duplicatedProforma = {
                ...row,
                id: newId,
                invoiceId: newInvoiceUid,
                date: Date.now().toString(),
                creationDate: Date.now().toString(),
                customInvoiceId: newCustomInvoiceId,
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                converted: "false" // Reset converted status for duplicate
            };

            // Remove Firebase specific ID
            delete duplicatedProforma.uniqueID;

            AddProformaInvoice(state, dispatch, duplicatedProforma, targetUid);
            toast.success("Proforma Invoice duplicated successfully");
        } catch (error) {
            console.error("Duplicate Proforma error:", error);
            toast.error("Failed to duplicate Proforma Invoice.");
        }
    };

    const columns = [
        {
            dataField: "srNo",
            text: Languages[state?.LANGUAGE]?.s_r,
            headerAlign: "center",
            align: "center",
            sort: true,
            search: false,
            formatter: (cell) => <span style={{ marginLeft: -8 }}>{cell}</span>,
            sortCaret: sortCaret,
            events: { onClick: (e, column, columnIndex, row) => OnClickOfRow(row?.invoiceId, row?.paidFlagKey) }
        },
        {
            dataField: "customInvoiceId",
            text: Languages[state?.LANGUAGE]?.invoice_no,
            headerAlign: "center",
            align: "center",
            sort: true,
            search: true,
            sortCaret: sortCaret,
            formatter: (cell, row) => {
                const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                const isShared = business?.isShared === true;

                const currentUserStr = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";
                const resolvedName = resolveAuditName(row.createdBy, state.membersData);
                const creatorName = (resolvedName === "Unknown" && business?.ownerName)
                    ? business.ownerName
                    : resolvedName;
                const isCreator = creatorName === currentUserStr || row.createdBy === currentUserStr || (typeof row.createdBy === 'object' && row.createdBy?.uid === state?.USERID);

                const showByLabel = row.createdBy
                    ? !isCreator
                    : (isShared && business?.ownerName);

                const displayName = row.createdBy ? creatorName : business?.ownerName;

                return (
                    <div style={{ marginLeft: -8 }}>
                        <div>{cell && cell.trim() !== "" ? cell : row?.id}</div>
                        {showByLabel && (
                            <small className="text-secondary-light" style={{ fontSize: '11px', display: 'block', marginTop: '-4px' }}>
                                by: {displayName}
                            </small>
                        )}
                    </div>
                );
            },
            searchFormatted: true,
            events: { onClick: (e, column, columnIndex, row) => OnClickOfRow(row?.invoiceId, row?.paidFlagKey) }
        },
        {
            dataField: "customerName",
            text: Languages[state?.LANGUAGE]?.customer_name,
            sort: true,
            search: true,
            sortCaret: sortCaret,
            searchFormatted: true,
            formatter: (cell, row) => {
                const business = state?.BUSINESSES?.find(b => String(b.companyId) === String(row.companyId));
                const isShared = business?.isShared === true;

                const currentUserStr = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";
                const resolvedName = resolveAuditName(row.createdBy, state.membersData);
                const creatorName = (resolvedName === "Unknown" && business?.ownerName)
                    ? business.ownerName
                    : resolvedName;
                const isCreator = creatorName === currentUserStr || row.createdBy === currentUserStr || (typeof row.createdBy === 'object' && row.createdBy?.uid === state?.USERID);

                const showByLabel = row.createdBy
                    ? !isCreator
                    : (isShared && business?.ownerName);

                const displayName = row.createdBy ? creatorName : business?.ownerName;

                return (
                    <div style={{ marginLeft: -8, cursor: "pointer" }}>
                        <div>{cell}</div>
                        {/* {showByLabel && (
                            <small className="text-secondary-light" style={{ fontSize: '11px', display: 'block', marginTop: '-4px' }}>
                                by: {displayName}
                            </small>
                        )} */}
                    </div>
                );
            },
            events: { onClick: (e, column, columnIndex, row) => OnClickOfRow(row?.invoiceId, row?.paidFlagKey) }
        },
        {
            dataField: "totalAmount",
            text: Languages[state?.LANGUAGE]?.amount,
            sort: true,
            search: true,
            formatter: (cell, row) => {
                const matchedCurrency = row?.currency ? Currancy.CountryCurrencyResponse.find(
                    (c) => c.currencyCode === row.currency
                ) : null;
                const currencyCode = matchedCurrency ? matchedCurrency.currencyCode : state?.CURRENCYCODE;
                const currencySymbol = matchedCurrency ? matchedCurrency.currencytSymbol : state?.SYMBOL;
                return (
                    <span>{currencySymbol === "$" ? `${currencyCode} ${currencySymbol} ` : `${currencySymbol} `} {cell}</span>
                );
            },
            searchFormatted: true,
            sortFunc: (a, b, order) => order === 'asc' ? Number(a) - Number(b) : Number(b) - Number(a)
        },
        {
            dataField: "issuedDateFormatted",
            text: Languages[state?.LANGUAGE]?.issued_date,
            sort: true,
            search: true,
            searchFormatted: true
        },
        {
            dataField: "convertedText",
            text: Languages[state?.LANGUAGE]?.status,
            sort: true,
            search: true,
            formatter: (cell, row) => (
                <span
                    className={`d-inline-block text-center px-24 py-4 rounded-pill fw-medium text-sm ${row.converted === "true"
                        ? "bg-success-focus text-success-main"  // green background if converted
                        : "bg-danger-focus text-danger-main"   // red if pending
                        }`}
                >
                    {cell}  {/* displays "converted" or "Pending" */}
                </span>
            ),
            searchFormatted: true
        },
        {
            dataField: "dueStatusText",
            text: "Due Status",
            headerAlign: "center",
            align: "center",
            formatter: (cell, row) => {
                if (!row.dueDate) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-danger-focus text-danger-main">
                            No Due Date
                        </span>
                    );
                }

                let dueDateNum = parseInt(row.dueDate);
                if (dueDateNum.toString().length === 10) {
                    dueDateNum = dueDateNum * 1000;
                }

                const dueDate = new Date(dueDateNum);
                const today = new Date();
                dueDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                const diffTime = dueDate.getTime() - today.getTime();
                const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

                if (diffDays === 0) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-warning-focus text-warning-main">
                            Due Today
                        </span>
                    );
                } else if (diffDays < 0) {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-danger-focus text-danger-main">
                            {Math.abs(diffDays)} {Math.abs(diffDays) === 1 ? "day" : "days"}
                        </span>
                    );
                } else {
                    return (
                        <span className="d-inline-block text-center px-16 py-4 rounded-pill fw-medium text-sm bg-success-focus text-success-main">
                            {diffDays} {diffDays === 1 ? "day" : "days"}
                        </span>
                    );
                }
            },
            sort: true,
            sortCaret: sortCaret,
            events: { onClick: (e, column, columnIndex, row) => OnClickOfRow(row?.invoiceId, row?.paidFlagKey) }
        },
        {
            dataField: "action",
            text: Languages[state?.LANGUAGE]?.action,
            headerAlign: "center",
            align: "center",
            formatter: (cell, row) => (
                <>
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            dispatch({ type: actionType.SELECTEDPROFORMAINVOICES, payload: row?.invoiceId });
                        }}
                        to="/invoice-preview"
                        className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-primary"
                        data-bs-title="View Proforma Invoice"
                    >
                        <Icon icon="iconamoon:eye-light" />
                    </Link>
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            dispatch({ type: actionType.SELECTEDPROFORMAINVOICES, payload: row?.invoiceId });
                        }}
                        to="/proformainvoic-edit"
                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-success"
                        data-bs-title="Edit Proforma Invoice"
                    >
                        <Icon icon="lucide:edit" />
                    </Link>
                    <Link
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-danger"
                        data-bs-title="Delete Proforma Invoice"
                    >
                        <DeleteProformaInvoiceView FirebaseId={row?.uniqueID} />
                    </Link>

                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                return;
                            }
                            handleDuplicate(row);
                        }}
                        className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-info"
                        data-bs-title="Duplicate Proforma Invoice"
                    >
                        <Icon icon="lucide:copy" />
                    </Link>

                    <div className="dropdown d-inline-block me-8">
                        <button
                            className="btn bg-primary-light text-primary-600 rounded-circle p-0 w-32-px h-32-px d-flex align-items-center justify-content-center"
                            type="button"
                            onClick={(e) => handleDropdownClick(e, row)}
                        >
                            <Icon icon="lucide:more-vertical" />
                        </button>

                        <ul className="dropdown-menu dropdown-top-left shadow-sm border-0 rounded-3 hide-scrollbar">
                            {row?.converted !== "true" && (
                                <li>
                                    <button
                                        className="dropdown-item rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                        onClick={(e) => {
                                            if (!state?.USERID) {
                                                dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
                                                return;
                                            }
                                            ConvertToInvoice(row);
                                            const dropdownMenu = e.currentTarget.closest(".dropdown-menu");
                                            if (dropdownMenu) {
                                                dropdownMenu.classList.remove("show");
                                            }
                                        }}

                                    >
                                        Convert to Invoice
                                    </button>
                                </li>
                            )}
                        </ul>
                    </div>
                </>
            )
        }
    ];

    const OnClickOfRow = (invoiceId, isPaid) => {
        if (!state?.USERID) {
            dispatch({ type: actionType.GUESTMODELPOPUP, payload: true });
            return;
        }
        dispatch({ type: actionType.SELECTEDPROFORMAINVOICES, payload: invoiceId })
        if (isPaid == "true" || isPaid == true) {
            navigate("/invoice-preview")
        }
        else {
            navigate("/proformainvoic-edit")
        }
    }

    const handleSelection = (val) => {
        setItemsPerPage(val)
        setCurrentPage(1)
    };

    return (
        <div className="card">
            <div className="card-body">
                <ToolkitProvider keyField="invoiceId" data={matchedInvoices} columns={columns} search>
                    {props => {
                        const searchText = props.searchProps.searchText?.toLowerCase() || "";

                        // Filter by search and selectedBusiness
                        const filteredSearchData = matchedInvoices.filter(item => {
                            const matchesBusiness = selectedBusiness === null || selectedBusiness === "null" || item.companyId == selectedBusiness;
                            const matchesSearch = item.invoiceNumber?.toLowerCase()?.includes(searchText) ||
                                item.customerName?.toLowerCase()?.includes(searchText) ||
                                item.customInvoiceId?.toString()?.toLowerCase().includes(searchText) ||
                                item.amount?.toString()?.toLowerCase().includes(searchText) ||
                                item.dueStatusText?.toLowerCase()?.includes(searchText);
                            return matchesBusiness && matchesSearch;
                        });

                        const start = (currentPage - 1) * itemsPerPage;
                        const paginatedData = filteredSearchData.slice(start, start + itemsPerPage)
                            .map((item, index) => ({ ...item, srNo: start + index + 1 }));

                        return (
                            <>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <SearchBar
                                        {...props.searchProps}
                                        placeholder={"Search Proforma Invoices..."}
                                        className="form-control w-auto"
                                    />
                                </div>

                                <div className="table-responsive">
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        bordered={false}
                                        data={paginatedData}
                                        wrapperClasses={`custom-table-border invoice-table ${localStorage.getItem("theme") === "dark" ? "table-dark" : "table-light"}`}
                                        noDataIndication={() => <DataNotFoundView height={400} />}
                                        rowStyle={{ cursor: "pointer" }}
                                    />
                                </div>

                                {filteredSearchData.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="d-flex align-items-center gap-2 entry_per_page">
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-outline-primary-600 not-active px-18 py-6 dropdown-toggle toggle-icon"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {itemsPerPage}
                                                </button>
                                                <ul className="dropdown-menu shadow-md">
                                                    {[5, 10, 15, 20].map(value => (
                                                        <li key={value}>
                                                            <Link
                                                                className={`dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 ${itemsPerPage === value && "bg-primary-50"}`}
                                                                onClick={() => { setItemsPerPage(value); setCurrentPage(1); }}
                                                            >
                                                                {value}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            <span className="text-secondary-light">{Languages[state?.LANGUAGE]?.entries_per_page}</span>
                                        </div>

                                        <div className="ms-auto">
                                            <PaginationView
                                                currentPage={currentPage}
                                                totalPages={Math.ceil(filteredSearchData.length / itemsPerPage)}
                                                handlePageChange={setCurrentPage}
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                        );
                    }}
                </ToolkitProvider>
            </div>
        </div>
    );
};

export default ProformaTableDataLayer;
